import BigNumber from 'bignumber.js';

export class DateHelper {
    public static getDateFromBigNumber(dateNumber: BigNumber): Date {
        let date = new Date(0);
        date.setUTCSeconds(dateNumber.toNumber());
        return date;
    }

    public static formatDateToLocaleString(item: Date): any {
        if (!item || (item == null)) return "";

        var current_date = item.getDate();
        var current_month = item.getMonth() + 1;
        var current_year = item.getFullYear();
        var current_hrs = item.getHours();
        var current_mins = item.getMinutes();
        var current_secs = item.getSeconds();
        var current_datetime;

        // Add 0 before date, month, hrs, mins or secs if they are less than 0
        let final_date = current_date < 10 ? '0' + current_date.toString() : current_date.toString();
        let final_month = current_month < 10 ? '0' + current_month.toString() : current_month.toString();
        let final_hrs = current_hrs < 10 ? '0' + current_hrs.toString() : current_hrs.toString();
        let final_mins = current_mins < 10 ? '0' + current_mins.toString() : current_mins.toString();
        let final_secs = current_secs < 10 ? '0' + current_secs.toString() : current_secs.toString();

        // Current datetime
        // String such as 2016-07-16T19:20
        current_datetime = current_year.toString() + '-' + final_month + '-' + final_date + 'T' + final_hrs + ':' + final_mins + ':' + final_secs;

        return current_datetime
    }

    public static getTimeFromDate(date: Date) {
        const newDate = new Date(date);
        return newDate.getTime();
    }

    public static formatToDateAndHour(date: Date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    public static convertDate(dateToBeConverted: Date) {
        var dateStringToBeConverted = dateToBeConverted.toString().replace(/-/g, '/').replace(/T/g, ' ') + " UTC";
        let convertedDate = new Date(dateStringToBeConverted);
        return convertedDate;
    }
}